import { Intent, Spinner } from "@blueprintjs/core"
import { useState } from "react"
import { Tooltip } from "@blueprintjs/core"

import AddNewTickerDialog from "../components/AddNewTickerDialog"
import {
  AddTickerButton,
  DetailCard,
  MainContainer,
  SearchContainer,
} from "../components/CommonStyled.styled"
import Instruments from "../components/Instruments"
import TickerSuggest from "../components/TickerSuggest"
import useTradingCompany from "../hooks/useTradingCompany"
import useTradingCompanies from "../hooks/useTradingCompanies"
import { TradingCompany } from "../types"
import CompanyForm from "./CompanyForm"

const Company = () => {
  const [selectedCompanyId, setSelectedCompanyId] = useState<number | undefined>(undefined)
  const [isOpenDialog, setIsOpenDialog] = useState(false)

  // Fetch full company details when a company is selected
  const { company: selectedCompany, isLoading: isLoadingDetail } = useTradingCompany({
    companyId: selectedCompanyId,
  })

  const useCompaniesWrapper = ({ query }: { query: string }) => {
    const { companies, isLoading, error } = useTradingCompanies({ query })
    return { items: companies ?? [], isLoading, error }
  }

  // Handler to select a company from the search results (light type)
  const handleSelectCompany = (company: TradingCompany | undefined) => {
    setSelectedCompanyId(company?.id)
  }

  return (
    <MainContainer flexDirection="column" alignItems="center" justifyContent="center" gap="30px">
      <SearchContainer flexDirection="row" alignItems="center" gap="10px">
        <TickerSuggest<TradingCompany>
          setSelectedItem={handleSelectCompany}
          useItems={useCompaniesWrapper}
          errorMessage="Unable to search companies, please try to refresh the page."
        />
        <Tooltip content="Add new ticker(s)">
          <AddTickerButton
            onClick={() => setIsOpenDialog(true)}
            icon="plus"
            intent={Intent.PRIMARY}
            minimal
            outlined
          />
        </Tooltip>
        <AddNewTickerDialog
          isOpenDialog={isOpenDialog}
          setIsOpenDialog={setIsOpenDialog}
          title="Add new ticker(s)"
        />
      </SearchContainer>

      {selectedCompanyId && isLoadingDetail && <Spinner />}

      {selectedCompany && (
        <DetailCard>
          <CompanyForm selectedCompany={selectedCompany} setSelectedCompanyId={setSelectedCompanyId} />
          <Instruments instruments={selectedCompany.all_related_instruments} />
        </DetailCard>
      )}
    </MainContainer>
  )
}

export default Company
